// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__iZwQE","whtBtn":"button_whtBtn__j6hZy"};